module.exports = __webpack_public_path__ + "static/media/remove.8a75e2f1.svg";